export default __webpack_public_path__ + "static/media/AirGroupImg.012df2f8.svg";